import { ReportColumnNames, ReportExtensions } from '@spa/api';

import {
    ReportTableColumn,
    ReportTableConfigInterface,
    ReportTableData,
    ReportTableDataRow,
    ReportTableGroupedColumn,
} from '../../../app/shared/components';

export const OpenPositionsDataTableItems = (isGroupReport: boolean): ReportTableData[] => {
    const tableDataItems = [
        new ReportTableData<string>({
            colId: ReportColumnNames.Symbol,
            value: null,
            hidden: false,
            shifted: false,
            class: "symbol-cell"
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.Account,
            value: null,
            hidden: false,
            shifted: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.Qty,
            value: null,
            hidden: false,
            shifted: true
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.AveragePrice,
            value: null,
            hidden: false,
            shifted: true
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.ClosePrice,
            value: null,
            hidden: false,
            shifted: true
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.CCY,
            value: null,
            hidden: false,
            shifted: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.Cost,
            value: null,
            hidden: false,
            shifted: true
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.MarketValue,
            value: null,
            hidden: false,
            shifted: true
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.Unrealized,
            value: null,
            hidden: false,
            shifted: true
        }),
    ];

    if (!isGroupReport) {
        return tableDataItems.filter((item: ReportTableData) => {
            return ([ReportColumnNames.Account.toString(), ReportColumnNames.Date.toString()].indexOf(item.colId) < 0);
        });
    }

    return tableDataItems;
};

export const OpenPositionsReportTableConfig = (isGroupReport: boolean): ReportTableConfigInterface => {
    const config = {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Symbol',
                selector: ReportColumnNames.Symbol
            }),
            new ReportTableColumn({
                label: 'Account',
                selector: ReportColumnNames.Account
            }),
            new ReportTableColumn({
                label: 'Qty',
                selector: ReportColumnNames.Qty,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Avg Price',
                selector: ReportColumnNames.AveragePrice,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Close Price',
                selector: ReportColumnNames.ClosePrice,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'CCY',
                selector: ReportColumnNames.CCY
            }),
            new ReportTableColumn({
                label: 'Cost',
                selector: ReportColumnNames.Cost,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Market Value',
                selector: ReportColumnNames.MarketValue,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Unrealized',
                selector: ReportColumnNames.Unrealized,
                shifted: true
            })
        ],
        sortByRowIndex: true,
        hasToggleableOrCheckableRows: isGroupReport,
        disableColumnsOptions: true,
        hiddenColumnIds: [],
        actionMenu: false
    };

    if (!isGroupReport) {
        config.columns = config.columns.filter((column: ReportTableColumn | ReportTableGroupedColumn) => {
            return ([
                ReportColumnNames.Account.toString(),
                ReportColumnNames.Date.toString()
            ].indexOf(column.selector) < 0);
        });
    }

    return config;
};

export const OpenPositionsReportTableFooterRow = (
    totalSymbolValue: string,
    cost: number,
    marketValue: number,
    unrealized: number,
    isGroupReport: boolean,
    isTotalNetRow: boolean,
    mainDataTableColumnsLength: number
): ReportTableDataRow => {
    return new ReportTableDataRow({
        rowId: totalSymbolValue,
        dataItems: [
            ...(new Array(mainDataTableColumnsLength - 4)).fill(null).map(() => {
                return new ReportTableData({
                    value: '',
                    colId: '',
                    hidden: false,
                });
            }),
            new ReportTableData({
                value: totalSymbolValue,
                colId: ReportColumnNames.Symbol,
                hidden: false,
                shifted: true
            }),
            new ReportTableData({
                value: !isTotalNetRow ? ReportExtensions.toDecimalString(cost) : '',
                colId: ReportColumnNames.Cost,
                hidden: false,
                hasNegativeValue: ReportExtensions.isNegative(cost),
                shifted: true
            }),
            new ReportTableData({
                value: !isTotalNetRow ? ReportExtensions.toDecimalString(marketValue) : '',
                colId: ReportColumnNames.MarketValue,
                hidden: false,
                hasNegativeValue: ReportExtensions.isNegative(marketValue),
                shifted: true
            }),
            new ReportTableData({
                value: ReportExtensions.toDecimalString(unrealized),
                colId: ReportColumnNames.Unrealized,
                hidden: false,
                hasNegativeValue: ReportExtensions.isNegative(unrealized),
                shifted: true
            }),
        ]
    });
};
